import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { font_family_weight_medium, font_sm } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  ${font_sm};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextSecondary};
  overflow: hidden;
  opacity: 1;

  &.alignRight {
    justify-content: flex-end;
  }

  & .headerName {
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 10;
  }
`
